<template>
  <div>

    <v-card :class="$style.retrobonuses_widget">
      <div :class="$style.widget_title">
        <span class="display-3">Ретро-бонусы</span>
      </div>
      <template>
        <div class="d-flex">
          <v-row>
            <v-col
              v-if="years !== null && years.length > 0"
              cols="12"
              xl="3"
              lg="4"
              md="6"
              sm="6"
              xs="12"
            >
              <Select
                :value="filters.year"
                :items="years"
                :class="[$style.select, $style.filterField]"
                label="Год"
                dense
                hide-details
                clearable
                blue_icon
                @input="filter_update('year', $event, 'retro_bonuses')"
              />
            </v-col>
            <v-col
              v-if="statuses !== null && statuses.length > 0"
              cols="12"
              xl="3"
              lg="4"
              md="6"
              sm="6"
              xs="12"
            >
              <Select
                :value="filters.status"
                :items="statuses"
                :class="[$style.select, $style.filterField]"
                label="Статус выплаты"
                item-text="name"
                item_value="slug"
                dense
                hide-details
                clearable
                blue_icon
                @input="filter_update('status', $event, 'retro_bonuses')"
              />
            </v-col>
          </v-row>
        </div>
      </template>

      <div class="d-flex flex-column justify-space-between my-4">
        <div
          class="d-flex justify-space-between"
          style="color: #696C86;"
        >
          <div
            class="py-2 pl-4"
            style="width: 50%;"
          >
            <span style="text-transform: uppercase; font-size: 11px;">Сценарии</span>
          </div>
          <div
            class="d-flex justify-space-around"
            style="width: 50%;"
          >
            <div
              class="d-flex justify-end py-2 col"
            >
              <span style="text-transform: uppercase; font-size: 11px;">План</span>
            </div>
            <div
              class="d-flex justify-end py-2 col"
              :class="$style.margin_title_is_mobile"
            >
              <span style="text-transform: uppercase; font-size: 11px;">Факт</span>
            </div>
            <div
              class="d-flex justify-end py-2 col"
              :class="[$style.paddin_title_is_mobile]"
            >
              <span style="text-transform: uppercase; font-size: 11px;">Премия</span>
            </div>
            <div
              class="d-flex justify-end py-2 col"
              :class="[$style.paddin_title_is_mobile]"
            >
              <span style="text-transform: uppercase; font-size: 11px;">Выплачено</span>
            </div>
          </div>
        </div>

        <div
          v-for="(item, index) in retro_bonus_items"
          :key="index"
          class="d-flex justify-space-between"
          :class="$style.row"
          style="font-size: 14px;"
        >
          <div
            class="py-2 pl-4 d-flex flex-column"
            style="width: 50%;"
          >
            <span style="font-size: 16px;">{{ item.scenario_title }} ({{ item.scenario_start_date | date }} - {{ item.scenario_end_date | date }})</span>
            <span>{{ item.contract_name }} № {{ item.contract_number }} от {{ item.contract_date | date }}</span>
          </div>
          <div
            class="d-flex justify-space-around"
            style="width: 50%;"
          >
            <div
              class="d-flex justify-end py-2 col"
            >
              <span>{{ item.plan }}</span>
            </div>
            <div
              class="d-flex justify-end py-2 col"
            >
              <span>{{ item.fact }}</span>
            </div>
            <div
              class="d-flex justify-end py-2 col"
              :class="$style.paddin_is_mobile"
            >
              <span class="font-weight-bold">{{ item.reward | currency_rub }}</span>
            </div>
            <div
              class="d-flex justify-end py-2 col"
              :class="$style.paddin_is_mobile"
            >
              <span class="font-weight-bold">{{ item.paid | currency_rub }}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="d-flex justify-space-between font-weight-bold">
        <span>Премия Итого</span>
        <span>{{ sum_reward | currency_rub }}</span>
      </div>

    </v-card>
  </div>
</template>

<script lang="ts">
import {
  Vue, Component, Emit,
} from 'vue-property-decorator';
import { widgets_store } from '@/store';
import { Select } from '@/components/global';
import { WidgetFilters } from '@/components/widgets/types';

const { state, mutations } = widgets_store;

@Component({
  components: {
    Select,
  },
})
export default class WidgetRetroBonuses extends Vue {
  @Emit()
  filter_update(key: keyof WidgetFilters, value: unknown, section: string) {
    mutations.UPD_FILTER_KEY({ key, value, section });
  }

  get retro_bonus() {
    return state.widgets?.retro_bonuses;
  }

  get retro_bonus_items() {
    return state.widgets?.retro_bonuses?.items;
  }

  get sum_reward() {
    return state.widgets?.retro_bonuses?.sum_reward;
  }

  get statuses() {
    return state.widgets?.retro_bonuses?.statuses;
  }

  get years() {
    return state.widgets?.retro_bonuses?.years;
  }

  get filters() {
    return state.filters;
  }
}
</script>

<style module lang="scss">
@import '@/scss/common/filter-blocks.scss';

.retrobonuses_widget {
  border: solid 1px black;
  display: flex;
  flex-direction: column;
  padding: 24px;
}
.widget_title {
  margin-bottom: 16px;
  font-style: 24px;
  font-weight: 600;
  line-height: 32px;
  color: #13141C;
}
.filterField {
  max-width: 100% !important;
}
.datepickerMargin {
  margin-bottom: -14px;
}
.row:nth-child(even) {
  background-color: #F6F7FA;
  border-radius: 8px;
}

@media (max-width: 599px) {
    .margin_title_is_mobile {
      margin-right: 4px;
    }
    .paddin_is_mobile {
      padding-right: 8px;
    }
    .paddin_title_is_mobile {
      padding-right: 8px;
    }
}
</style>
